import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../models/api.model';

export interface IDeliveryNoteLock {
  _id?: string;
  deliveryNoteId: string;
  userId: string;
  employeeId: string;
  createdAt?: Date;
}

@Injectable({
  providedIn: 'root',
})
export class DeliveryNoteLockService {
  private readonly apiUrl = `${environment.apiUrl}/delivery-note-lock`;

  constructor(private http: HttpClient) {}

  public createLock(deliveryNoteId: string, employeeId: string): Observable<ApiResponse<IDeliveryNoteLock>> {
    // userId is derived server-side from the JWT, not sent from here.
    return this.http.post<ApiResponse<IDeliveryNoteLock>>(this.apiUrl, { deliveryNoteId, employeeId });
  }

  public deleteLock(deliveryNoteId: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${deliveryNoteId}`);
  }

  public getLock(deliveryNoteId: string): Observable<ApiResponse<IDeliveryNoteLock | null>> {
    return this.http.get<ApiResponse<IDeliveryNoteLock | null>>(`${this.apiUrl}/${deliveryNoteId}`);
  }
}
